//@flow
import firebase from 'firebase'
import { isProduction } from 'configs/index'

export const initFirebase = () => {
  if(isProduction()){
    console.log('REACT_APP_ENV: production');
    firebase.initializeApp({
      apiKey: "AIzaSyC_X6iaTE3sIKPByEU9lHPOl7heKG7g1qE",
      authDomain: "cryptorunup.firebaseapp.com",
      databaseURL: "https://cryptorunup.firebaseio.com",
      projectId: "cryptorunup"
    })
  }else{
    console.log('REACT_APP_ENV: development');
    firebase.initializeApp({
      apiKey: "AIzaSyC_X6iaTE3sIKPByEU9lHPOl7heKG7g1qE",
      authDomain: "cryptorunup.firebaseapp.com",
      databaseURL: "https://cryptorunup.firebaseio.com",
      projectId: "cryptorunup"
    })
  }

  return {type: 'FIREBASE_INITIALIZED'}
}

export const db = () => firebase.database()



// WEBPACK FOOTER //
// ./src/actions/firebaseInit.js